import { SpinnerIcon } from '@/lib/Spinner';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const WaZoneLoading: FC = () => {
  const { t } = useTranslation('comuni');

  return (
    <div className='flex flex-col items-center gap-3 rounded-xl border border-gray-200 px-4 py-8' role='status' aria-busy='true'>
      <SpinnerIcon className='size-8 text-brand-700' />
      <p className='text-sm text-tertiary-600'>{t('modelli.waLoading')}</p>
    </div>
  );
};
